import React, { useContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import {
  Home as HomeIcon,
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Restaurant as RestaurantIcon,
  Person as PersonIcon,
  Logout as LogoutIcon,
  HourglassEmpty as HourglassEmptyIcon,
  MenuBook as MenuBookIcon,
} from '@mui/icons-material';
import { AuthContext } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';
import { useIsMobile } from '../../hooks';
import { colors, layout, mobile } from '../../styles/tokens';

/**
 * Configuration de la navigation Admin (Desktop - Sidebar)
 */
const adminNavItems = [
  {
    section: 'Principal',
    items: [
      { label: 'Dashboard', icon: DashboardIcon, path: '/admin' },
      { label: 'Coachs', icon: PeopleIcon, path: '/admin/coaches' },
      { label: 'Waiting List', icon: HourglassEmptyIcon, path: '/admin/waiting-list' },
    ],
  },
  {
    section: 'Contenu',
    items: [
      { label: 'Recettes', icon: RestaurantIcon, path: '/admin/recipes' },
      { label: 'Documentation', icon: MenuBookIcon, path: '/admin/documentation' },
    ],
  },
  {
    section: 'Compte',
    items: [
      { label: 'Profil', icon: PersonIcon, path: '/admin/profile' },
      { label: 'Deconnexion', icon: LogoutIcon, action: 'logout' },
    ],
  },
];

/**
 * Configuration de la navigation Admin (Mobile - Bottom Nav)
 */
const adminMobileNavItems = [
  { label: 'Accueil', icon: HomeIcon, path: '/admin' },
  { label: 'Coachs', icon: PeopleIcon, path: '/admin/coaches' },
  { label: 'Recettes', icon: RestaurantIcon, path: '/admin/recipes' },
  { label: 'Profil', icon: PersonIcon, path: '/admin/profile' },
];

/**
 * Layout Admin avec Sidebar (desktop) ou BottomNav (mobile)
 */
const AdminLayout = () => {
  const { logout, user } = useContext(AuthContext);
  const { isMobileOrTablet } = useIsMobile();
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar - Desktop only */}
      {!isMobileOrTablet && (
        <Sidebar
          navItems={adminNavItems}
          title="Admin"
          onLogout={logout}
          user={user}
        />
      )}

      {/* Contenu principal */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: '100vh',
          // IMPORTANT: Eviter debordement horizontal
          width: '100%',
          maxWidth: '100%',
          overflowX: 'hidden',
          bgcolor: colors.bgPage,
          // Mobile: padding bottom pour bottom nav + safe area
          pb: isMobileOrTablet ? `calc(${mobile.bottomNavHeight}px + ${mobile.safeAreaBottom} + 16px)` : 0,
        }}
      >
        {/* Zone de contenu avec padding uniforme */}
        <Box
          sx={{
            // Padding responsive uniforme
            px: { xs: 2, sm: 3 },
            py: { xs: 2, sm: 3 },
            // Mobile: safe area top
            pt: isMobileOrTablet ? `calc(${mobile.safeAreaTop} + 16px)` : { xs: 2, sm: 3 },
            // Eviter debordement
            boxSizing: 'border-box',
            width: '100%',
            maxWidth: isMobileOrTablet ? '100%' : layout.maxWidth,
          }}
        >
          <Outlet />
        </Box>
      </Box>

      {/* Bottom Navigation - Mobile only */}
      {isMobileOrTablet && (
        <BottomNav navItems={adminMobileNavItems} />
      )}
    </Box>
  );
};

export default AdminLayout;
